import { render, staticRenderFns } from "./litter-reminder-notes.vue?vue&type=template&id=58aeb7d8&scoped=true&lang=pug"
import script from "./litter-reminder-notes.js?vue&type=script&lang=js&external"
export * from "./litter-reminder-notes.js?vue&type=script&lang=js&external"
import style0 from "./litter-reminder-notes.vue?vue&type=style&index=0&id=58aeb7d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aeb7d8",
  null
  
)

export default component.exports